import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
import request from '../../../utils/request';

export default {
    baseurl: '/api/swyl/v1/fanli/hetong',

    //客户数量统计列表查询
    pagecount(query) {
        return http({
            url: this.baseurl + '/flContractAgent/getcustomerCountTablePage',
            method: 'post',
            params: query
        });
    },
    //客户返利报表列表查询
    pagefanliTable(query) {
        return http({
            url: this.baseurl + '/flContractAgent/getFanliTablePage',
            method: 'post',
            params: query
        });
    },

    //客户返利报表列表查询getFanliTableZongjiPage
    getFanliTableZongji(query) {
        return http({
            url: this.baseurl + '/flContractAgent/getFanliTableZongjiPage',
            method: 'post',
            params: query
        });
    },
    //客户履约报表列表查询
    pagecustomerLyTongji(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectLvyueTongjiPage',
            method: 'post',
            params: query
        });
    },

//客户行为报表查询
    pagecustomer(query) {
        return http({
            url: this.baseurl + '/flContractAgent/getCustomerTablePage',
            method: 'post',
            params: query
        });
    },

    pagecustomerLevel(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/selectAgentLevelPage',
            method: 'post',
            params: query
        });
    },
    //
    page(query) {
        return http({
            url: this.baseurl + '/flContractAgent/selectPage',
            method: 'post',
            params: query
        });
    },
    pagefanliXsjl(query) {
        return http({
            url: '/api/swyl/v1/demo/flXsjlTarget/selectPage',
            method: 'post',
            params: query
        });
    },
    daoru(query) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/daoruPage',
            method: 'post',
            params: query
        });
    },
    //返利计算明细列表查询
    pagelist(query) {
        return http({
            url: '/api/swyl/v1/demo/viewFlAgentTarget/selectPage',
            method: 'post',
            params: query
        });
    },
    //更新修改的返利金额
    updateMonthFanli(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/updateMonthFanliPage',
            method: 'post',
            data: query
        });
    },
    //汇算返利计算基础数据
    gatherFlShujuBase(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/gatherFlShujuBase',
            method: 'post',
            timeout: 1200 * 1000,
            params: query
        });
    },
    gatherFlSales(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/gatherFlSales',
            method: 'post',
            timeout: 1200 * 1000,
            params: query
        });
    },
    //返利计算
    fanlijisuan(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/MonthRebateAmount',
            method: 'post',
            timeout: 1200 * 1000,
            params: query
        });
    },
    //传入下个月返利计算
    nextMonthFanli(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/chuanruNextMonthFanliPage',
            method: 'post',
            data: query
        });
    },
    //传入SAP
    chuanruSAP(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/chuanruSapPage',
            method: 'post',
            data: query
        });
    },
    //客户履约报表列表查询
    pageCustomerLyTable(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectPage',
            method: 'post',
            params: query
        });
    },
    chanPinTable(query) {
        return http({
            url: '/api/swyl/v1/demo/flXsptCategory/selectPage',
            method: 'post',
            params: query
        });
    },
    //客户履约销售报表列表查询
    pageCustomerLyXiaoshouTable(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectLvyueXiaoshouPage',
            method: 'post',
            data: query
        });
    },
    //客户履约报表列表总计查询
    pageCustomerLyZongjiTable(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectZongjiPage',
            method: 'post',
            params: query
        });
    },
    pageQuanxian(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectquanxianPage',
            method: 'post',
            params: query
        });
    },
    pageQuanxianXiaoshou(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectquanxianXiaoshouPage',
            method: 'post',
            params: query
        });
    },
    pagecpbbQuanxian(query) {
        return http({
            url: '/api/swyl/v1/demo/flXsptCategory/selectquanxianPage',
            method: 'post',
            params: query
        });
    },
    pageQuanxianYonghu(query) {
        return http({
            url: '/api/swyl/v1/fanli/hetong/flContractAgent/selectquanxianPage',
            method: 'post',
            params: query
        });
    },
    //客户履约报表列表销售总计查询
    pageCustomerLyZongjiXiaoshouTable(query) {
        return http({
            url: '/api/swyl/v1/demo/viewLvyueTable/selectZongjixiaoshouPage',
            method: 'post',
            data: query
        });
    },
    query(query) {
        return http({
            url: this.baseurl + '/flSamePeriod/selectPage',
            method: 'post',
            params: query
        });
    },
    querentijia(query) {
        return http({
            url: this.baseurl + '/flContractBase/insert',
            method: 'post',
            data: query
        });
    },
    querentijiaLianqun(query) {
        return http({
            url: '/api/swyl/v1/demo/flProductLianqun/insert',
            method: 'post',
            params: query
        });
    },
    querentijiao(query) {
        return http({
            url: this.baseurl + '/flContractBaseTj/insert',
            method: 'post',
            params: query
        });
    },
    //合同详情查询
    chakan(query) {
        return http({
            url: this.baseurl + '/flContractAgent/selectById?id=' + query,
            method: 'post',
            params: query
        });
    },
    //合同签订-获取合同名称
    showHtName() {
        return http({
            url: '/api/swyl/v1/fanli/hetong/flContractBase/showHtName',
            method: 'post'
        });
    },
    //合同签订-暂存合同
    submitHT(query) {
        return http({
            url: '/api/swyl/v1/fanli/hetong/flContractAgent/submitHT',
            method: 'post',
            data: query
        });
    },
    //合同签订-暂存合同
    submitHTTuichu(query) {
        return http({
            url: '/api/swyl/v1/fanli/hetong/flContractAgent/submitHTTuichu',
            method: 'post',
            data: query
        });
    },
    //审核返利合同
    checkFanliContract(query) {
        return http({
            url: this.baseurl + '/flContractAgent/checkFanliContract',
            method: 'post',
            data: query
        });

    },
    //审核销售经理导入返利合同
    checkFanliContractXsjl(v) {
        return http.post('/api/swyl/v1/demo/flXsjlTarget/checkFanliContractXsjl?msg=' + v);
    },

    checkFanliGoalXiugai(query) {
        return http.post('/api/swyl/v1/demo/flNewTargetXiugai/checkFanliGoalXiugai?flagMsg=' + query);
    },

    //审核返利合同
    checkFanliTuichuContract(query) {
        return http({
            url: this.baseurl + '/flContractAgent/checkFanliTuichuContract ',
            method: 'post',
            data: query
        });
    },
    //查看合同
    selectTarget(v) {
        return http.post('/api/swyl/v1/fanli/hetong/flContractAgent/selectById?id=' + v);
    },
    //查看销售经理导入合同信息
    selectTargetXsjl(v) {
        return http.post('/api/swyl/v1/demo/flNewTarget/selectShujuShenhe?instid=' + v);
    },

    selectGoalShenpi(v) {
        return http.post('/api/swyl/v1/demo/flNewTargetXiugai/selectGoalShenpi?instid=' + v);
    },
    //查看返利详情
    selectfanliXiangqing(v) {
        return http.post('/api/swyl/v1/fanli/hetong/flContractAgent/selectById?id=' + v);
    },
    xiugaihistory(v) {
        return http({
            url: '/api/swyl/v1/demo/flNewTargetXiugai/xiugaihistory',
            method: 'post',
            params: v
        });
    },
    getYuti(query) {
        return http({
            url: '/api/swyl/v1/demo/flJemsYuti/getYutiPage',
            method: 'post',
            params: query
        });
    },
    //传入GEMS
    updateGems(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/chuanruGemsPage',
            method: 'post',
            data: query
        });
    },
    //传入报账中心
    updateGemsNew(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/chuanruGemsPageNew',
            method: 'post',
            data: query
        });
    },
    //重新合计
    updateHeji(query) {
        return http({
            url: this.baseurl + '/flContractAgentTarget/updateHeji',
            method: 'post',
            data: query
        });
    },
    getYutiXiangqing(query) {
        return http({
            url: '/api/swyl/v1/demo/flJemsYuti/getYutiXiangqingPage',
            method: 'post',
            params: query
        });
    },

    tuichu(v) {
        return http({
            url: '/api/swyl/v1/fanli/hetong/flContractAgent/tuichu',
            method: 'post',
            params: v
        });
    },
    queryNewEtBilling(v) {
        return http({
            url: '/api/swyl/v1/demo/newEtBilling/queryNewEtBillingPage',
            method: 'post',
            params: v
        });
    },
    selectDuiXianPage(v) {
        return http({
            url: '/api/swyl/v1/fanli/duixian/flCash/selectPage',
            method: 'post',
            params: v
        });
    },
    selectDuiXianTotal(v) {
        return http({
            url: '/api/swyl/v1/fanli/duixian/flCash/selectTotal',
            method: 'post',
            params: v
        });
    },
    //开票
    flInvoiceInfoPage(v) {
        return http({
            url: '/api/swyl/v1/demo/newEtBilling/flInvoiceInfoPage',
            method: 'post',
            params: v
        });
    },
    getInvoiceLog() {
        return http.post('/api/swyl/v1/demo/newEtBilling/getInvoiceLog');
    },
    getLyQudaoPage(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyQudaoPage',
            method: 'post',
            params: v
        });
    },
    getLyQudaoExitPage(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyQudaoExitPage',
            method: 'post',
            params: v
        });
    },
    getSelection() {
        return http.post('/api/swyl/v1/fl/flQudaoSalesVolume/getSelection');
    },
    getLyQudaoTotal(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyQudaoTotal',
            method: 'post',
            params: v
        });
    },
    getLyQudaoExitTotal(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyQudaoExitTotal',
            method: 'post',
            params: v
        });
    },
    zfPushSAP(v) {
        return http({
            url: '/api/swyl/v1/fanli/duixian/flCash/zfPushSAP',
            method: 'post',
            data: v
        });
    },
    newPushSAP() {
        return http.post('/api/swyl/v1/fanli/duixian/flCash/newPushSAP');
    },
    //获取当前登录经销商的返利实际与目标差额提醒
    showAgentSalesTixing() {
        return http.post('/api/swyl/v1/demo/flNewTarget/showAgentSalesTixing');
    },
    //将当前提醒置为已提醒
    remindedAgentSalesTixing(v) {
        return http.post('/api/swyl/v1/demo/flNewTarget/remindedAgentSalesTixing?id=' + v);
    },
    //差额报表分页方法
    flSamePeriodPage(v) {
        return http({
            url: '/api/swyl/fanli/hetong/viewFlSamePeriodDiffer/selectPage',
            method: 'post',
            params: v
        });
    },
    //传统客户返利报表分页
    rebateResultPage(query) {
        return http({
            url: '/api/swyl/v1/demo/viewFlAgentTarget/rebateResultPage',
            method: 'post',
            params: query
        });
    },
    rebateResultTotal(query) {
        return http({
            url: '/api/swyl/v1/demo/viewFlAgentTarget/rebateResultTotal',
            method: 'post',
            params: query
        });
    },

    downloadExcelPrint(query) {
        return http({
            url: '/api/swyl/v1/demo/flXsjlTarget/downloadPrintCheck',
            method: 'post',
            params: query
        });
    },
    //2024履约报表分页
    getLy2024Page(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2024Page',
            method: 'post',
            params: v
        });
    },
    getLy2024Total(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2024Total',
            method: 'post',
            params: v
        });
    },
    /*2024客户履约统计报表（客户履约分类统计）*/
    //列表分页
    customerLvyueTongjiPage(query) {
        return http({
            url: '/api/swyl/fl/viewFlLvyueTongji/customerLvyueTongjiPage',
            method: 'post',
            params: query
        });
    },
    //根据公司名称获取目标、销额
    getTargetByCustomer(agent, areaCode, field) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/getTargetByCustomer',
            method: 'post',
            params: {customerName: agent, areaCode: areaCode, field: field}
        });
    },
    //根据公司名称获取基数
    getBaseByCustomer(agent, areaCode, field) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/getBaseByCustomer',
            method: 'post',
            params: {customerName: agent, areaCode: areaCode, field: field}
        });
    },
    //根据公司名称获取已得到的返利
    getFlByCustomer(agent, areaCode, field) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/getFlByCustomer',
            method: 'post',
            params: {customerName: agent, areaCode: areaCode, field: field}
        });
    },
    rebateLog(agentName, radio) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/rebateLog',
            method: 'post',
            params: {agentName: agentName, radio: radio}
        });
    },
    //打开页面
    openTable() {
        return http.post('/api/swyl/v1/demo/flNewTarget/openTable');
    },
    getCustomerPage(agent) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/getCustomerPage',
            method: 'post',
            params: {agentName: agent}
        });
    },
    getRebateLogPage(entity) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/getRebateLogPage',
            method: 'post',
            params: entity
        });
    },
    //当前登录人
    localAgent() {
        return http.post('/api/swyl/v1/demo/flNewTarget/localAgent');
    },

    /****
     *目标历史节点暂存表接口
     */
    pagefanliXsjlContractLog(query) {
        return http({
            url: '/api/swyl/v1/demo/flNewTargetContractLog/selectPage',
            method: 'post',
            params: query
        });
    },

    //2025履约报表分页
    getLy2025Page(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2025Page',
            method: 'post',
            params: v
        });
    },

    //2025履约报表厚宏分页
    getLyhh2025Page(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2025HouhongPage',
            method: 'post',
            params: v
        });
    },
    getLy2025Total(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2025Total',
            method: 'post',
            params: v
        });
    },

    //2026履约报表分页
    getLy2026Page(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2026Page',
            method: 'post',
            data: v
        });
    },

    //2026履约报表汇总
    getLy2026Total(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2026Total',
            method: 'post',
            data: v
        });
    },

    /**
     * 目标导入审批回退到平台节点（临时接口）
     * @param {String} instid 流程实例ID
     */
    rollbackGoalImportToPingtai(instid) {
        return http({
            url: '/api/swyl/v1/demo/flXsjlTarget/rollbackToPingtai',
            method: 'get',
            params: {instid}
        });
    },
    //全部销额报表分页
    selectAllOrderPage(v) {
        return http({
            url: '/api/swyl/v1/demo/flAllOrderSales/selectPage',
            method: 'post',
            params: v
        });
    },
    //全部销额报表统计
    selectAllOrderTotal(v) {
        return http({
            url: '/api/swyl/v1/demo/flAllOrderSales/selectTotal',
            method: 'post',
            params: v
        });
    },
    //分销商安装量报表分页
    selectFxServiceSalesPage(v) {
        return http({
            url: '/api/swyl/v1/fanli/flFxServiceOrder/selectPage',
            method: 'post',
            params: v
        });
    },
    //分销商安装量明细表分页
    selectFxServiceSalesDetailPage(v) {
        return http({
            url: '/api/swyl/v1/fanli/flFxServiceOrder/selectDetailPage',
            method: 'post',
            params: v
        });
    },
    //分销商上平台量报表分页
    selectFxServiceNumPage(v) {
        return http({
            url: '/api/swyl/v1/fanli/flFxServiceOrder/selectFxServiceNumPage',
            method: 'post',
            params: v
        });
    },
    //分销商上平台量明细分页
    selectFxServiceNumDetailPage(v) {
        return http({
            url: '/api/swyl/v1/fanli/flFxServiceOrder/selectFxServiceNumDetailPage',
            method: 'post',
            params: v
        });
    },
    //累计履约报表分页
    getLyAllPage(v) {
        return http({
            url: '/api/swyl/v1/fanli/flLvyueTableAll/getLyTableAllPage',
            method: 'post',
            params: v
        });
    },
    getLyAllTotal(v) {
        return http({
            url: '/api/swyl/v1/fanli/flLvyueTableAll/getLyTableAllTotal',
            method: 'post',
            params: v
        });
    },
    selectFxServiceNumTotal(v) {
        return http({
            url: '/api/swyl/v1/fanli/flFxServiceOrder/getFxAgentNumSum',
            method: 'post',
            params: v
        });
    },
    //履约报表 区分链群
    getLyLqPage(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyLqPage',
            method: 'post',
            params: v
        });
    },
    getLyLqTotal(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyLqTotal',
            method: 'post',
            params: v
        });
    },    //履约报表 区分链群
    getLyLqPage2025(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyLqPage2025',
            method: 'post',
            params: v
        });
    },
    getLyLqTotal2025(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLyLqTotal2025',
            method: 'post',
            params: v
        });
    },
    // 2026厚履约报表
    getLy2026HouPage(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2026HouPage',
            method: 'post',
            params: v
        });
    },
    getLy2026HouTotal(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getLy2026HouTotal',
            method: 'post',
            params: v
        });
    },

    // 价格层级与履约状态报表
    getPriceLevelAndLvyueStatusReport(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getPriceLevelAndLvyueStatusReport',
            method: 'post',
            params: v
        });
    },

    // 获取单个价格层级
    getPriceLevel(v) {
        return http({
            url: '/api/swyl/v1/fl/flQudaoSalesVolume/getPriceLevel',
            method: 'post',
            params: v
        });
    },

    //网络达标率报表分页查询
    networkCompliancePage(v) {
        return http({
            url: '/api/swyl/v1/fl/networkCompliance/selectPage',
            method: 'post',
            params: v
        });
    },

}
